import {
    GET_BOOKING_LIST,
    GET_BOOKING_LIST_SUCCESS,
    CREATE_BOOKING,
    CREATE_BOOKING_SUCCESS,
    UPDATE_BOOKING,
    UPDATE_BOOKING_SUCCESS,
    DELETE_BOOKING,
    GET_BOOKING_BY_ID,
    GET_BOOKING_BY_ID_SUCCESS,
    GET_AVAILABLE_ROOMS,
    GET_AVAILABLE_ROOMS_SUCCESS,
    GET_AVAILABLE_ROOMS_ERROR,
    CHANGE_ROOM,
    CHANGE_ROOM_SUCCESS,
    CHANGE_ROOM_ERROR,
    UPGRADE_ROOM,
    UPGRADE_ROOM_SUCCESS,
    UPGRADE_ROOM_ERROR,
    GET_BOOKINGS_BY_PATIENT,
    GET_BOOKINGS_BY_PATIENT_SUCCESS,
} from '../storeTypes';

export const ActionGetBookingList = (payload, callBack) => {
    return {
        type: GET_BOOKING_LIST,
        payload,
        callBack,
    };
};

export const ActionGetBookingListSuccess = (payload) => {
    return {
        type: GET_BOOKING_LIST_SUCCESS,
        payload,
    };
};

export const ActionCreateBooking = (payload, callBack) => {
    return {
        type: CREATE_BOOKING,
        payload,
        callBack,
    };
};

export const ActionCreateBookingSuccess = (payload) => {
    return {
        type: CREATE_BOOKING_SUCCESS,
        payload,
    };
};

export const ActionUpdateBooking = (payload, callBack) => {
    return {
        type: UPDATE_BOOKING,
        payload,
        callBack,
    };
};

export const ActionUpdateBookingSuccess = (payload) => {
    return {
        type: UPDATE_BOOKING_SUCCESS,
        payload,
    };
};

export const ActionDeleteBooking = (payload, callBack) => {
    return {
        type: DELETE_BOOKING,
        payload,
        callBack,
    };
};

export const ActionGetBookingById = (payload, callBack) => {
    return {
        type: GET_BOOKING_BY_ID,
        payload,
        callBack,
    };
};

export const ActionGetBookingByIdSuccess = (payload) => {
    return {
        type: GET_BOOKING_BY_ID_SUCCESS,
        payload,
    };
};

export const ActionGetAvailableRooms = (payload, callBack) => {
    return {
        type: GET_AVAILABLE_ROOMS,
        payload,
        callBack,
    };
};

export const ActionGetAvailableRoomsSuccess = (payload) => {
    return {
        type: GET_AVAILABLE_ROOMS_SUCCESS,
        payload,
    };
};

export const ActionGetAvailableRoomsError = (error) => {
    return {
        type: GET_AVAILABLE_ROOMS_ERROR,
        error,
    };
};

export const ActionChangeRoom = (payload, callBack) => {
    return {
        type: CHANGE_ROOM,
        payload,
        callBack,
    };
};

export const ActionChangeRoomSuccess = (payload) => {
    return {
        type: CHANGE_ROOM_SUCCESS,
        payload,
    };
};

export const ActionChangeRoomError = (error) => {
    return {
        type: CHANGE_ROOM_ERROR,
        error,
    };
};

export const ActionUpgradeRoom = (payload, callBack) => {
    return {
        type: UPGRADE_ROOM,
        payload,
        callBack,
    };
};

export const ActionUpgradeRoomSuccess = (payload) => {
    return {
        type: UPGRADE_ROOM_SUCCESS,
        payload,
    };
};

export const ActionUpgradeRoomError = (error) => {
    return {
        type: UPGRADE_ROOM_ERROR,
        error,
    };
};

export const ActionGetBookingsByPatient = (payload, callBack) => {
    return {
        type: GET_BOOKINGS_BY_PATIENT,
        payload,
        callBack,
    };
};

export const ActionGetBookingsByPatientSuccess = (payload) => {
    return {
        type: GET_BOOKINGS_BY_PATIENT_SUCCESS,
        payload,
    };
};

